<div class="container">
  <div class="card">
    <div class="task-head">
      <h4>Required!</h4>
    </div>

    <form [formGroup]="newTaskForm" class="form-vertical">
      <div fxLyout="column">
        <div fxLyout="row" fxLayoutAlign="center center" style="align-items: start;">
          <div style="align-items: start; display: flex;flex-direction: column;">
            <div>
              <mat-label class="card-label">Selected Target<span>*</span></mat-label>
              <mat-form-field appearance="outline" class="optionDetails">
                <input matInput formControlName="target" class="selectMatDetails" readonly #inputField />
              </mat-form-field>
              <span matTooltipClass="custom-point-tooltip" matTooltip="{{poiWkt}}" style="padding-left: 3px;">
                <img width="20px" height="20" [src]="tooltipImagePath" />
              </span>
            </div>

            <div>
              <mat-label class="card-label">Sensor Type<span>*</span></mat-label>
              <mat-form-field appearance="outline" class="optionDetails">
                <mat-select [disableOptionCentering]="true" panelClass="matopenpurposes"
                  placeholder=" Select sensor type " class="selectDetails" formControlName="sensorType"
                  (selectionChange)="sensorChange($event.value)">
                  <mat-option *ngFor="let option of filteredSensorTypes" [value]="option"
                  [disabled]="(option.name === 'AIS')">{{option.name}}
                    <img style="margin-left: 10px;" width="17px" height="17" [src]="tooltipImagePath"
                    [matTooltip]="option.description"/>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div>
              <mat-label class="card-label">Cloud Cover<span>*</span></mat-label>
              <mat-form-field appearance="outline" class="optionDetails">
                <mat-select [disableOptionCentering]="true" panelClass="matopenpurposes" placeholder="Select cloud cover"
                  formControlName="cloudCover" style="color: rgba(0, 0, 0, 0.42)" class="selectDetails">
                  <mat-option *ngFor="let option of this.outComesensor?.cloudCover; let i = index" [value]="option.key">
                    {{ option.key }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-label class="card-label">How Soon?<span>*</span></mat-label>
              <mat-form-field appearance="outline" class="optionDetails">
                <input matInput placeholder="Hours" formControlName="latency" maxlength="5" class="selectMatDetails"
                  #inputField (ngModelChange)="onKeyChange('latency')" />
                <mat-error *ngIf="newTaskForm.get('latency').hasError('min') && newTaskForm.get('latency').touched" class="error">
                  Minimum hours should be 24
                </mat-error>
                <mat-error *ngIf="newTaskForm.get('latency').hasError('pattern') && newTaskForm.get('latency').touched" class="error">
                  Invalid hours
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div style="align-items: end; display: flex;flex-direction: column; padding-left: 20px; padding-bottom: 106px;">
            <div>
              <mat-label class="card-label">Task Name<span>*</span></mat-label>
              <mat-form-field appearance="outline" class="optionDetails">
                <input matInput placeholder="Your task name" formControlName="taskName" class="selectMatDetails"
                  #inputField (ngModelChange)="onKeyChange('taskName')" />
                  <mat-error *ngIf="newTaskForm.get('taskName').hasError('minlength') && newTaskForm.get('taskName').touched" class="error">
                    At least 5 characters long
                  </mat-error>  
              </mat-form-field>
            </div>
            <div>
              <mat-label class="card-label">Resolution<span>*</span></mat-label>
              <mat-form-field appearance="outline" class="optionDetails">
                <mat-select [disableOptionCentering]="true" panelClass="matopenpurposes" placeholder="Select resolution"
                  formControlName="resolution" style="color: rgba(0, 0, 0, 0.42)" class="selectDetails">
                  <mat-option *ngFor="let option of this.outComesensor?.resolution; let i = index" [value]="option">
                    {{ option.key }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-label class="card-label">Intent<span>*</span></mat-label>
              <mat-form-field appearance="outline" class="optionDetails">
                <mat-select [disableOptionCentering]="true" panelClass="matopenpurposes"
                  placeholder=" Select intent " class="selectDetails" formControlName="intent">
                  <mat-option *ngFor="let option of intentOption" [value]="option"
                  [disabled]="(option.name === 'AIS')">{{option.name}}
                    <span style="margin-left: 5px;" *ngIf="option?.description">
                          <img width="17px" alt ="" [src]="tooltipImagePath"
                            [matTooltip]="option.description"/>
                    </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="btns" fxLayoutAlign="center center" fxLyout="row">
          <button mat-stroked-button (click)="onNoClick()">Cancel</button>
          <button style="margin-left: 13px !important;" mat-stroked-button [disabled]="newTaskForm.invalid || outComeError
          || outComeSubmit"
            (click)="onSubmit()" class="submit">Submit</button>
        </div>
      </div>
    </form>

  </div>
</div>